const DefaultItemCategory = Object.freeze({
  PRESTATION: '1',
  COFFIN: '2',
  URNS: '3',
  OTHER: '4',
  ZINC: '5',
  CAPITONS: '6',
  COMPOSANTS_CERCUEIL: '7',
  Pack: 'packs'
})

export default DefaultItemCategory
